import * as DashColors from 'bd-web-components/src/utils/dash-colors';

/**
 * Função que retorna uma cor baseada na variável de ambiente REBRAND
 * @param defaultColor - Cor retornada quando REBRAND é false
 * @param rebrandColor - Cor opcional retornada quando REBRAND é true
 * @returns A cor apropriada baseada na configuração REBRAND
 */
export const getColor = (defaultColor: string, rebrandColor?: string): string => {
  const isRebrand = process.env.REACT_APP_REBRAND === 'true';

  if (isRebrand && rebrandColor) {
    return rebrandColor;
  }

  return defaultColor;
};

/**
 * Função auxiliar para obter cores do dash-colors com suporte a rebrand
 * @param defaultColorName - Nome da cor padrão do dash-colors
 * @param rebrandColorName - Nome opcional da cor de rebrand do dash-colors
 * @returns A cor apropriada baseada na configuração REBRAND
 */
export const getDashColor = (defaultColorName: keyof typeof DashColors, rebrandColorName?: keyof typeof DashColors): string => {
  const isRebrand = process.env.REACT_APP_REBRAND === 'true';

  if (isRebrand && rebrandColorName && DashColors[rebrandColorName]) {
    return DashColors[rebrandColorName];
  }

  return DashColors[defaultColorName];
};

// Re-export all colors from dash-colors for convenience
export * from 'bd-web-components/src/utils/dash-colors';
